import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { S3_URL_PRODUCTS } from "../utils/constants";
import { AuthContext } from "../contexts/AuthContext";
import { addToWishlist } from "../services/authenticatedRequests";
import { toast } from "react-toastify";
const ProductListThree = ({ products }) => {
  const { isAuthenticated, logout, user } = useContext(AuthContext);
  const [isWishlistSubmitting, setIsWishlistSubmitting] = useState(false);
  const handleAddToWishlist = async (productId) => {
    if (isWishlistSubmitting) {
      return;
    }
    setIsWishlistSubmitting(true);
    try {
      await addToWishlist(productId);
      window.dispatchEvent(new Event("wishlistUpdated"));
      toast.success("Item added to wishlist");
    } catch (error) {
      console.error(error);
      const errorMessage =
        error?.response?.data || "An unexpected error occurred";
      toast.error(`Error adding to wishlist: ${errorMessage}`);
    } finally {
      setIsWishlistSubmitting(false);
    }
  };
  return (
    <div className="product mt-24">
        <div className="row gy-4 g-12">
          {products && products.length > 0 ? (
            products.map((product) => (
              <div
                className="col-xl-2 col-lg-3 col-sm-4 col-6"
                key={product.id}
              >
                <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                  {isAuthenticated && (
                    <button
                      disabled={isWishlistSubmitting}
                      onClick={() => handleAddToWishlist(product.id)}
                      className={`product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16 ${
                        isWishlistSubmitting
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
                    >
                      {isWishlistSubmitting ? (
                        <i className="ph ph-spinner animate-spin" /> // Loading icon
                      ) : (
                        <i className="ph ph-heart" />
                      )}
                    </button>
                  )}
                  <Link
                    to={`/product-details/${product.id}`}
                    className="product-card__thumb flex-center"
                  >
                    <img
                      src={`${S3_URL_PRODUCTS}${product.images?.[0]}`}
                      alt={product.name}
                    />
                  </Link>

                  <div className="product-card__content">
                    <h6 className="title text-sm fw-semibold">
                      <Link
                        to={`/product-details/${product.id}`}
                        className="link text-line-2"
                        title={product.name}
                      >
                        {product.name.length > 20
                          ? `${product.name.slice(0, 20)}...`
                          : product.name}
                      </Link>
                    </h6>
                    <div className="product-card__price">
                      {product.salePrice ? (
                        <>
                          <div className="d-flex align-items-center gap-4">
                            <span className="text-gray-400 text-sm fw-semibold text-decoration-line-through">
                              LKR {product.regularPrice.toFixed(2)}
                            </span>
                            <span className="badge bg-main-600 text-white text-sm fw-semibold">
                              -
                              {Math.round(
                                ((product.regularPrice - product.salePrice) /
                                  product.regularPrice) *
                                  100
                              )}
                              %
                            </span>
                          </div>
                          <span className="text-heading text-sm fw-semibold">
                            LKR {product.salePrice.toFixed(2)}
                          </span>
                        </>
                      ) : (
                        <span className="text-heading text-sm fw-semibold">
                          LKR {product.regularPrice.toFixed(2)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center w-100">No products found</p>
          )}
        </div>
      </div>
  );
};

export default ProductListThree;
